import type { State } from 'state';

export const getLinkedSpaces = (state: State): string[] => {
    const linkedSpacesState = state.persisted.linkedSpaces;

    if (!linkedSpacesState) {
        return [];
    }

    return linkedSpacesState.linkedSpaces || [];
};
